var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36 8v56c-8.5604 0-15.5-12.536-15.5-28s6.9396-28 15.5-28 15.5 12.536 15.5 28-6.9396 28-15.5 28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64 36h-56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m60 22h-48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m60 50h-48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangPic);
export default __webpack_public_path__ + "static/media/lang-pic.766c531e2a7ce4c908c0a05fb4ed5318.svg";
export { ForwardRef as ReactComponent };